// ============================================================================
// Which subcontractors may be CHOSEN on a project service line. 2026-09-02.
//
// ⛔ PICKERS EXCLUDE, RESOLVERS RESOLVE (TCSD-0129), AND A CALL SITE THAT IS
// BOTH IS SPLIT RATHER THAN NARROWED (TCSD-0163). This rule governs the LIST
// only. The pool a saved value resolves against is left whole, so a line that
// already points at a retired sub still shows that sub's name.
//
// That is not hypothetical: the flat <select> this replaces was built on
// `.eq('provider_status','Active')`, so 81 saved service lines — 46 Merged and
// 35 Inactive — render as "Not assigned yet" today even though a sub IS
// recorded on them. Anyone reading those lines believes nobody was assigned.
//
// Ben's rulings, 2026-09-02:
//   D2 — the 13 non-field vendors come OFF the list. 5 Back_Office,
//        4 Professional_Services and 4 Staffing were being offered as the answer
//        to "who cleaned this building". SmartSelect's own fetch already filters
//        provider_class='Field_Service' (the 2026-06-16 split), so this is
//        inherited, not written here. No service line has ever used one of the
//        13, so nothing in the book changes.
//   D3 — PENDING STAYS SELECTABLE. "DO NOT STOP REALITY (someone is cleaning
//        the facility) due to ADMIN SLOWNESS." A sub whose paperwork has not
//        cleared is still the sub who did the work, and refusing to record that
//        does not un-do it. Only Inactive and Merged are excluded — a retired
//        sub and a duplicate that has been folded into another record.
// ============================================================================

/** Statuses a sub may NOT be newly assigned under. Everything else may. */
export const UNSELECTABLE_PROVIDER_STATUSES = ['Inactive', 'Merged'] as const;

/**
 * ⚠️ Deliberately permissive about what it does not recognise. A status this
 * list has never heard of — a new one added next year — stays SELECTABLE, so a
 * vocabulary change cannot silently make subs unassignable and strand an AM
 * with work that happened and no way to record who did it.
 */
export interface SelectableProviderRow {
  /**
   * The source row as fetched. `provider_status` is read from here.
   *
   * ⛔ No index signature: this must stay ASSIGNABLE FROM `SmartSelectRow`, and
   * an index signature would break that in the other direction.
   */
  raw?: Record<string, unknown> | null;
}

export function isProviderSelectable(row: SelectableProviderRow): boolean {
  const status = row.raw?.['provider_status'];
  if (typeof status !== 'string') return true;
  return !(UNSELECTABLE_PROVIDER_STATUSES as readonly string[]).includes(status);
}
